
import React from 'react';
import {
    createBrowserRouter,
    RouterProvider,
  } from "react-router-dom";

import App from './app';
import Login from './login';
import NotFund from './notfund';
import MarkdownView from './markdown';


const router = createBrowserRouter([
  {
    path: "/login",
    element: (
      <Login />
    ),
  },
  {
    path: "/app",
    element: <App />,
    children:[
      {
        path: "home",
        element: (
          <MarkdownView markdownPath={"/docs/home"} />
        ),
      },
      {
        path: "payin",
        children:[
          {
            path: "submit",
            element: (
              <MarkdownView markdownPath={"/docs/payin/submit"} />
            ),
          },
          {
            path: "query",
            element: (
              <MarkdownView markdownPath={"/docs/payin/query"} />
            ),
          },
          {
            path: "notify",
            element: (
              <MarkdownView markdownPath={"/docs/payin/notify"} />
            ),
          }
        ]
      },
      {
        path: "payout",
        children:[
          {
            path: "submit",
            element: (
              <MarkdownView markdownPath={"/docs/payout/submit"} />
            ),
          },
          {
            path: "query",
            element: (
              <MarkdownView markdownPath={"/docs/payout/query"} />
            ),
          },
          {
            path: "notify",
            element: (
              <MarkdownView markdownPath={"/docs/payout/notify"} />
            ),
          }
        ]
      },
      {
        path: "balance",
        children:[
          {
            path: "query",
            element: (
              <MarkdownView markdownPath={"/docs/balance/query"} />
            ),
          },
        ]
      },
      {
        path: "bot",
        children:[
          {
            path: "fill",
            element: (
              <MarkdownView markdownPath={"/docs/bot/fill"} />
            ),
          },
        ]
      }
    ]
  },
  {
    path: "/",
    element: (
      <Login />
    ),
  },
  {
    path: "*",
    element: (
      <NotFund />
    ),
  }
]);

const MyRouter:React.FC = ()=>{
    return (
        <>
            <RouterProvider router={router} future={{ v7_startTransition: true, v7_relativeSplatPath: true}} />
        </>
    )
}

export default MyRouter